<template>
  <b-modal
    id="modal_tyyppi"
    size="xl">
    <template slot="modal-header" slot-scope="{ close }">
      <button type="button" class="close" aria-label="Close" @click="close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <template slot="default">
      <b-container fluid v-if="item.id">
        <b-row id="ro-info">
          <b-col cols="3">
            <b-form-group
              class="m-print-group"
              label="Suunnittelija"
              label-size="sm"
              label-for="m-print-1"
            >
              <b-form-input id="m-print-1" v-model="single.suunnittelija"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group
              class="m-print-group"
              label="Työn nro."
              label-size="sm"
              label-for="m-print-2"
            >
              <b-form-input id="m-print-2" v-model="single.tyonro"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group
              class="m-print-group"
              label="Tekijä"
              label-size="sm"
              label-for="m-print-3"
            >
              <b-form-input id="m-print-3" v-model="single.tekija"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group
              class="m-print-group"
              label="Pvm."
              label-size="sm"
              label-for="m-print-4"
            >
              <b-form-input id="m-print-4" v-model="single.pvm"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group
              class="m-print-group"
              label="Tunnus"
              label-size="sm"
              label-for="m-print-5"
            >
              <b-form-input
                id="m-print-5"
                v-model="item.acf.tunnus"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group
              class="m-print-group"
              label="Rakennuskohde"
              label-size="sm"
              label-for="m-print-6"
            >
              <b-form-input id="m-print-6" v-model="single.rakennuskohde"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group
              class="m-print-group"
              label="Sisältö"
              label-size="sm"
              label-for="m-print-7"
            >
              <b-form-textarea
                class="m-print-7"
                rows="4"
                max-rows="4"
                :placeholder="fixLineBreak(item.acf.sisalto)"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-3 mb-5" :id="'item_' + item.id">
          <Item
            :item="item"
            :paloluokka="paloluokka"
            :pintaluokat="pintaluokat"
            :kayttotarkoitus="kayttotarkoitus"
          />
        </b-row>
      </b-container>
    </template>
    <template slot="modal-footer" slot-scope="{ close }" class="no-print">
      <b-row id="m-footer" class="no-print">
        <b-col id="m-footerLeft" align="right">
          <b-button @click="close()" class="mr-2">Takaisin</b-button>
          <b-button class="blue-button mr-2" @click="printPage()">Tulosta</b-button>
          <!--
          <b-button class="blue-button mr-4" @click="makePDF()">
            <font-awesome-icon icon="file-pdf"></font-awesome-icon>
            Tallenna PDF
          </b-button> -->
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>
<script>
import Item from './Item.vue'

export default {
  name: 'Modal',
  components: {Item},
  props: {
    item: Object,
    fields: Array,
    paloluokka: String,
    kayttotarkoitus: String,
    pintaluokat: Object
  },
  data () {
    return {
      single: {
        suunnittelija: '',
        tyonro: '',
        tekija: '',
        pvm: '',
        tunnus: '',
        rakennuskohde: '',
        sisalto: ''
      }
    }
  },
  methods: {
    printPage () {
      window.print()
    },
    makePDF () {
      this.userSelection.single = this.single
      this.$emit('pdf')
    },
    fixLineBreak (content) {
      return content.replace(/\s*<br *\/? *>\s*/gi, '\n')
    }
  }
}
</script>
<style scoped>
  #ro-info {
    background: #f6f6f6;
    padding: 2em;
  }

  .ro-margin {
    margin: 0;
    width: 100%;
  }

  #m-footer {
    width: 100%;
  }

  #m-print :first-child {
    margin-right: 0.5rem;
  }

  .m-print-group {
    font-weight: bold;
  }

  .blue-button {
    background: #006fb9;
  }

  .m-container {
    margin-left: auto;
    margin-right: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue